module.exports = __webpack_public_path__ + "img/bg@xs.fc529d3e.jpg";